module.exports = __webpack_public_path__ + "img/server-2.1eb777a1.png";